import createRestfulModule from './restful-module'

export default createRestfulModule({

  state: {
    path: 'operation-record', // 资源路径
  }
})
